import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import ActiveLink from "@/components/ActiveLink";
import { ContractButtonLink, FavoriteButton, ShareButton } from "@/components/Buttons/index";
import Canvas from "@/components/Canvas";
import ChannelLiveSchedule from "@/components/ChannelLiveSchedule";
import { ChannelSearchForm, ChannelSearchFormSp } from "@/components/Form/index";
import ChannelHeroImage from "@/components/Images/ChannelHeroImage";
import Loading from "@/components/Loading";
import ChannelDetailMetaTags from "@/components/MetaTags/ChannelDetailMetaTags";
import OverflowMenu from "@/components/OverflowMenu";
import Palette from "@/components/Palette";
import { useBreadcrumbs, useChannelDetailQuery } from "@/hooks";
import { channelTag } from "@/lib/metaUtil";
import routes from "@/lib/routes";
import styles from "@/styles/Channel.module.scss";
import classnames from "classnames";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";
var IconContracted = function IconContracted(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M14.91.547l-4.98,8L7.122,4.923",
      transform: "translate(-5.719 0.83)",
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2"
    })
  }));
};
IconContracted.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10.568",
  height: "10.377",
  viewBox: "0 0 10.568 10.377"
};
var IconTag = function IconTag(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M.5.5H14.4l4.9,5-4.8,5H.6C.5,7.2.5,3.8.5.5Z",
      fill: "none",
      stroke: "#aaa",
      strokeMiterlimit: "10",
      strokeWidth: "1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.8,7.3a1.8,1.8,0,1,1,1.8-1.8,1.793,1.793,0,0,1-1.8,1.8Z",
      fill: "none",
      stroke: "#aaa",
      strokeWidth: "1"
    })]
  }));
};
IconTag.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "11",
  viewBox: "0 0 20 11"
};
import FormatPriceSVOD from "@/components/FormatPriceSVOD";
import MemberFree from "@/components/MemberFree";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var __N_SSP = true;
export default function ChannelDetail() {
  var _channel$rights$, _channel$rights, _selectLink$values, _selectLink$values2, _selectLink$values3;
  const router = useRouter();
  const id = parseInt(router.query.id, 10);
  const hash = true ? window.location.hash.substring(1) : null;
  const {
    0: selectLink,
    1: setLink
  } = useState();
  const {
    setBreadcrumbs
  } = useBreadcrumbs();
  const {
    loading,
    data
  } = useChannelDetailQuery({
    variables: {
      id,
      withTabMenu: true,
      withEntitlement: true
    }
  });
  const channel = data === null || data === void 0 ? void 0 : data.channel;
  const entitlements = data === null || data === void 0 ? void 0 : data.entitlements;
  const course = data === null || data === void 0 ? void 0 : data.course;
  const isMemberFree = (channel === null || channel === void 0 ? void 0 : channel.rights_control_type) === "member_only" && (channel === null || channel === void 0 || (_channel$rights$ = channel.rights[0]) === null || _channel$rights$ === void 0 ? void 0 : _channel$rights$.price) === 0;
  useEffect(() => {
    setBreadcrumbs([{
      text: "ホーム",
      href: routes.home
    }, {
      text: "月額商品一覧",
      href: routes.channels
    }, {
      text: channel.name
    }]);
  }, [channel]);
  useEffect(() => {
    const tabMenu = channel === null || channel === void 0 ? void 0 : channel.tabMenu;
    if (tabMenu) {
      const link = tabMenu.find(tab => tab.url === hash);
      if (link) {
        setLink(link);
      } else {
        setLink(tabMenu[0]);
        router.replace({
          pathname: router.pathame,
          query: {
            id
          },
          hash: tabMenu[0].url
        }, undefined, {
          scroll: false,
          shallow: true
        });
      }
    }
  }, [channel, hash]);
  const handleSearch = useCallback(data => {
    router.push(routes.channelDetailSearch(id, data.search));
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [loading && /*#__PURE__*/_jsx(Loading, {
      fixed: true
    }), /*#__PURE__*/_jsx(ChannelDetailMetaTags, {
      channel: channel,
      link: selectLink,
      course: course
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.detail,
      children: [/*#__PURE__*/_jsx(ChannelHeroImage, {
        channel: channel
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.info,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.section,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.detail,
            children: [/*#__PURE__*/_jsxs("h1", {
              className: styles.title,
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.titleText,
                children: channel.name
              }), entitlements.length > 0 && /*#__PURE__*/_jsxs("span", {
                className: styles.contractStatus,
                children: [/*#__PURE__*/_jsx(IconContracted, {}), "\u8CFC\u5165\u4E2D"]
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: styles.summary,
              children: channel.header
            }), entitlements.length === 0 && /*#__PURE__*/_jsx("div", {
              className: styles.price,
              children: isMemberFree ? /*#__PURE__*/_jsx(MemberFree, {}) : /*#__PURE__*/_jsx(FormatPriceSVOD, {
                price: channel === null || channel === void 0 || (_channel$rights = channel.rights) === null || _channel$rights === void 0 || (_channel$rights = _channel$rights[0]) === null || _channel$rights === void 0 ? void 0 : _channel$rights.price,
                course: course
              })
            })]
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: classnames(styles.section, styles.buttons),
          children: [entitlements.length == 0 && !isMemberFree && /*#__PURE__*/_jsx(ContractButtonLink, {
            course: course,
            medium: true
          }), /*#__PURE__*/_jsx(FavoriteButton, {
            metaId: channel.id
          }), /*#__PURE__*/_jsx(ShareButton, {
            title: channel.name
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.menu,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.tab,
          children: channel.tabMenu && /*#__PURE__*/_jsx(OverflowMenu, {
            children: channel.tabMenu.map(tab => /*#__PURE__*/_jsx(ActiveLink, {
              href: routes.channelDetail(id, tab.url),
              scroll: false,
              shallow: false,
              children: /*#__PURE__*/_jsx("div", {
                className: styles.link,
                children: /*#__PURE__*/_jsx("a", {
                  children: /*#__PURE__*/_jsx("span", {
                    children: tab.title
                  })
                })
              })
            }, `channel-${id}-${tab.url}`))
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.search,
          children: [/*#__PURE__*/_jsx(ChannelSearchForm, {
            onSubmit: handleSearch
          }), /*#__PURE__*/_jsx(ChannelSearchFormSp, {
            onSubmit: handleSearch
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.menuContent,
        children: [channel.tabMenu && /*#__PURE__*/_jsxs(_Fragment, {
          children: [selectLink == channel.tabMenu[0] && /*#__PURE__*/_jsxs("div", {
            className: styles.verbose,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.tag,
              children: [/*#__PURE__*/_jsx(IconTag, {}), channelTag(channel)]
            }), /*#__PURE__*/_jsx("p", {
              children: channel.description
            })]
          }), (selectLink === null || selectLink === void 0 || (_selectLink$values = selectLink.values) === null || _selectLink$values === void 0 ? void 0 : _selectLink$values.view_type) == "canvas" && /*#__PURE__*/_jsx(Canvas, {
            idKey: selectLink.values.canvas,
            hiddenPrice: true
          }), (selectLink === null || selectLink === void 0 || (_selectLink$values2 = selectLink.values) === null || _selectLink$values2 === void 0 ? void 0 : _selectLink$values2.view_type) == "palette" && /*#__PURE__*/_jsx(Palette, {
            id: selectLink.values.palette,
            hiddenPrice: true
          }), (selectLink === null || selectLink === void 0 || (_selectLink$values3 = selectLink.values) === null || _selectLink$values3 === void 0 ? void 0 : _selectLink$values3.view_type) == "live_schedule" && /*#__PURE__*/_jsx(ChannelLiveSchedule, {
            id: id
          })]
        }), !channel.tabMenu && /*#__PURE__*/_jsxs("div", {
          className: styles.verbose,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.tag,
            children: [/*#__PURE__*/_jsx(IconTag, {}), channelTag(channel)]
          }), /*#__PURE__*/_jsx("p", {
            children: channel.description
          })]
        })]
      })]
    })]
  });
}